import { Controller } from "@hotwired/stimulus"
import { post, patch, destroy } from "@rails/request.js"

export default class extends Controller {
  static targets = ["item", "container"]

  dragStart(event) {
    this.draggedItem = this.#itemContaining(event.target)
    this.sourceContainer = this.#containerContaining(this.draggedItem)

    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.dropEffect = "move"
    event.dataTransfer.setData("text/plain", this.draggedItem.dataset.id)
    event.dataTransfer.setDragImage(this.draggedItem, event.offsetX, event.offsetY)

    requestAnimationFrame(() => {
      this.draggedItem.dataset.dragging = ""
    })
  }

  dragOver(event) {
    if (!this.draggedItem) return

    event.preventDefault()
    this.#clearDropTargets()

    const container = this.#containerContaining(event.target)
    if (container && container !== this.sourceContainer) {
      container.dataset.dropTarget = ''
    }
  }

  dragLeave(event) {
    const container = this.#containerContaining(event.target)
    if (container && !container.contains(event.relatedTarget)) {
      delete container.dataset.dropTarget
    }
  }

  async drop(event) {
    event.preventDefault()

    const container = this.#containerContaining(event.target)
    if (!container || container === this.sourceContainer) return

    this.#clearDropTargets()
    await this.#submitDropRequest(container)
  }

  dragEnd() {
    if (this.draggedItem) {
      delete this.draggedItem.dataset.dragging
    }
    this.#clearDropTargets()

    this.draggedItem = null
    this.sourceContainer = null
  }

  #itemContaining(element) {
    return this.itemTargets.find(item => item.contains(element) || item === element)
  }

  #containerContaining(element) {
    return this.containerTargets.find(container => container.contains(element) || container === element)
  }

  #clearDropTargets() {
    this.containerTargets.forEach(container => delete container.dataset.dropTarget)
  }

  async #submitDropRequest(container) {
    const id = this.draggedItem.dataset.id
    const url = container.dataset.dropUrl.replace("__id__", id)
    const method = container.dataset.dropMethod || "patch"

    const body = new FormData()
    if (container.dataset.dropParams) {
      const params = JSON.parse(container.dataset.dropParams)
      Object.entries(params).forEach(([key, value]) => {
        body.append(key, value)
      })
    }

    const headers = { Accept: "text/vnd.turbo-stream.html" }
    const requests = { post, patch, destroy }
    return requests[method](url, { body, headers })
  }
}
